function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from '../../utils/classNames';
import getStarRatingStarsState, { STAR_STATE } from '../getStarRatingStarsState';
import Icon from '../../Icon';
import Radio from '../../Radio';
import RadioGroup from '../../RadioGroup';
import STAR_SVG_TYPE from '../starSvgType';
/**
 * The StarRatingUpdateable component displays a set of star SVGs to visualize rating value.
 * This component supports updating the star rating value.
 *
 * ## Related Components
 * - [StarRatingReadOnly](../StarRatingReadOnly/README.md)
 *
 * ## Composed of
 * - [Icon](../../Icon/README.md)
 * - [Radio](../../Radio/README.md)
 * - [RadioGroup](../../RadioGroup/README.md)
 *
 * ## Usage
 * ```jsx
 * <StarRating
 *  onRatingChange={onChange}
 *  readOnly={false}
 *  starSize="4"
 *  value={0}
 *  maxValue={5}
 * />
 * ```
 *
 * ## Props
 */

var StarRatingUpdateable = function StarRatingUpdateable(props) {
  var trackClicks = props.trackClicks,
      telemetryMetas = props.telemetryMetas,
      labelForRatings = props.labelForRatings,
      maxValue = props.maxValue,
      name = props.name,
      onRatingChange = props.onRatingChange,
      qa = props.qa,
      starSize = props.starSize,
      value = props.value;

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      ratingValue = _useState2[0],
      setRatingValue = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      hoverValue = _useState4[0],
      setHoverValue = _useState4[1];

  useEffect(function () {
    if (onRatingChange) {
      onRatingChange(ratingValue);
    }
  }, [ratingValue]);

  var _onMouseEnter = function onMouseEnter(newHoverValue) {
    return setHoverValue(newHoverValue);
  };

  var onMouseLeave = function onMouseLeave() {
    return setHoverValue(0);
  };

  var onRatingChanged = function onRatingChanged(e) {
    var newValue = e.target.value;
    var newRatingValue = parseInt(newValue, 10);
    setRatingValue(newRatingValue);
    setHoverValue(0);
  };

  var getStarClassName = function getStarClassName(_ref) {
    var config = _ref.config,
        _ref$newHoverValue = _ref.newHoverValue,
        newHoverValue = _ref$newHoverValue === void 0 ? 0 : _ref$newHoverValue;

    if (hoverValue !== 0) {
      // If the hover is on currently active hover value, use empty hovered star
      if (newHoverValue === hoverValue) return STAR_SVG_TYPE.EMPTY_HOVERED;
      /**
       * Explanation by example:
       * - The current hovered value is 3 so we will show star rating with value >= 4
       * as empty star and every other star as full star
       */

      return newHoverValue < hoverValue ? STAR_SVG_TYPE.FULL : STAR_SVG_TYPE.EMPTY;
    }

    if (config === STAR_STATE.FULL) return STAR_SVG_TYPE.FULL;
    if (config === STAR_STATE.EMPTY) return STAR_SVG_TYPE.EMPTY;
    return STAR_SVG_TYPE.HALF;
  };

  var ratingConfigs = getStarRatingStarsState(ratingValue, maxValue);
  return /*#__PURE__*/React.createElement(RadioGroup, {
    className: "psw-star-rating",
    qa: "".concat(qa, "#rating-group"),
    name: name,
    onChange: onRatingChanged
  }, ratingConfigs.map(function (config, idx) {
    return /*#__PURE__*/React.createElement("div", {
      className: "psw-l-line-left",
      key: "star-value-updateable-".concat(idx + 1),
      onMouseEnter: function onMouseEnter() {
        return _onMouseEnter(idx + 1);
      },
      onMouseLeave: onMouseLeave
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: idx + 1 === ratingValue,
      className: classNames('psw-m-x-1', 'psw-ally-indicator', 'psw-ally-indicator-gap-0'),
      qa: "".concat(qa, "#rating-").concat(idx + 1),
      trackClick: trackClicks === null || trackClicks === void 0 ? void 0 : trackClicks[idx + 1],
      telemetryMeta: telemetryMetas === null || telemetryMetas === void 0 ? void 0 : telemetryMetas[idx + 1],
      value: idx + 1,
      variant: "content"
    }, /*#__PURE__*/React.createElement(Icon, {
      qa: "".concat(qa, "#rating-").concat(idx + 1, "#icon"),
      label: labelForRatings[idx],
      size: starSize,
      type: getStarClassName({
        config: config,
        newHoverValue: idx + 1
      })
    })));
  }));
};

StarRatingUpdateable.defaultProps = {
  labelForRatings: ['1 star', '2 stars', '3 stars', '4 stars', '5 stars'],
  onRatingChange: function onRatingChange() {},
  maxValue: 5,
  name: 'productrating',
  qa: '',
  starSize: '5',
  telemetryMetas: null,
  trackClicks: null,
  value: 0
};
StarRatingUpdateable.propTypes = {
  /**
   * The label for the ratings
   */
  labelForRatings: PropTypes.arrayOf(PropTypes.string),

  /**
   * The max value of rating
   */
  maxValue: PropTypes.number,

  /**
   * The name used for the grouped radio buttons used for star rating
   */
  name: PropTypes.string,

  /**
   * Callback called when a new rating is selected (applicable to updateable star rating only)
   */
  onRatingChange: PropTypes.func,

  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * The size of star icon to render
   */
  starSize: PropTypes.string,

  /**
   * An object of telemetry meta for each rating value
   * It will be in format of < rating value> : <telemetry meta>
   * ex: { 1: JSON.stringify({ productId })}
   */
  telemetryMetas: PropTypes.objectOf(PropTypes.string),

  /**
   * An object of track click for each rating value
   * It will be in format of < rating value> : <data-track-click name>
   * ex: { 1: 'starRating:addRating' )}
   */
  trackClicks: PropTypes.objectOf(PropTypes.string),

  /**
   * The rating value
   */
  value: PropTypes.number
};
export default StarRatingUpdateable;